import { Network } from "../network";
import { NFTNetworkProps } from "../nft";
export { STATUS_CODES } from "./statusCodes";

const DEFAULT_PATH = "ref/hot";
const DEFAULT_PATH_V2 = "ref/v2";

export enum API_ROUTES {
  RISK = `${DEFAULT_PATH}/risk`,
  TRUST = `${DEFAULT_PATH}/trust`,
  TOTAL_SCORE = `${DEFAULT_PATH}/total_score`,
  MINT = `${DEFAULT_PATH}/mint`,
  USER = `${DEFAULT_PATH}/user`,
  GET_GRAPH = `${DEFAULT_PATH}/get_graph`,
  UPDATE_MINT = `${DEFAULT_PATH}/update_mint`,
  READ_NEWS = `${DEFAULT_PATH}/readnews`,

  ONBOARDING = `${DEFAULT_PATH}/onboarding`,
  CONNECT_TELEGRAM = `${DEFAULT_PATH}/addtg`,
  CONNECT_TWITTER = `${DEFAULT_PATH}/auth_twitter`,

  LOG_ATTEST = `${DEFAULT_PATH}/logattest`,
  LOG_ERROR = `${DEFAULT_PATH}/logerror`,

  AIRDROP = `${DEFAULT_PATH}/airdrop`,
}

export enum API_ROUTES_V2 {
  TRUST = `${DEFAULT_PATH_V2}/score`,
  USER = `${DEFAULT_PATH_V2}/get-user`,
  TON_PAYLOAD = `${DEFAULT_PATH_V2}/ton-payload`,
  TON_LOGIN = `${DEFAULT_PATH_V2}/ton-login`,
}

export const achievementsArray = ["holder", "villager", "trader", "winner"] as const;
export const hapiAchievementsArray = ["hapiHero"] as const;

export type HapiAchievementType = (typeof hapiAchievementsArray)[number];
export type AchievementType = (typeof achievementsArray)[number] | HapiAchievementType;

export interface Achievement {
  id: AchievementType;
  levels: Array<{ text: string; complete: boolean; action?: () => void }>;
}

export interface UserResponseData {
  isWaitingMint: boolean;
  news: string | null;
  scores: Array<{
    network: Network;
    score: number | null;
    isMinted: boolean;
    expirationDate: number | null;
    top1000: number | null;
    rating: number | null; // percent
  }>;
  nfts: Record<Network, NFTNetworkProps>;
  x: boolean;
  telegram: boolean;
  achievements: Array<Achievement>;
  totalScore: number;
}
export interface UserResponseDataV2 {
  isWaitingMint: boolean;
  scores: Array<{
    blockChain: Network;
    trustScore: number | null;
    isMinted: boolean;
    expirationDate: number | null;
    top1000: number | null;
    rating: number | null; // percent
  }>;
  nfts: Array<{
    network: Network;
    url: string | null;
    mintingFee: string;
    nftUnlockDate: number;
    isPurchased: boolean;
    isSoldOut: boolean;
    minAllowedScore: number;
    nftId: string | null;
  }>;
  telegram: boolean;
  achievements: Array<Achievement>;
}

export interface TrustResponseData {
  wallet: string;
  trust: number;
  expiration: number;
  validUntil: number;
  signature: string;
  validation?: string;
  attestationId?: string | null;
  recovery_id?: string;
  isRemint?: boolean;
}

export interface TotalScoreData {
  signature: string;
  minted: boolean;
  total_score: number;
}

export interface RiskResponseData {
  address: string;
  network: string;
  risk: number;
  category: string;
}

export type GraphResponseData = {
  errorCode: 0;
  data: {
    total_transaction: number;
    unique_accounts: number;
    wallet_age: number;
    wallet_name: number;
    wallet_balance: number;
    hot_achivments: number;
    nft: number;
    social_score: number;
    hapi_achivments: number;
    staked_near: number;
  };
};
export type GraphData = GraphResponseData["data"];

export type SuccessResponse = { errorCode: 0 };
export type ErrorResponse = { errorCode: 1; message: string };

export type BasicResponseV2Score = { errorCode: 0 | 1; score: number; expiration: number; signature: string };
export type BasicResponseV2 = { errorCode: 0 | 1; payload?: string };
export type BasicResponseV2Auth = { errorCode: 0 | 1; jwt: string };

export type BasicResponse = SuccessResponse | ErrorResponse;

export type RiskResponse = ErrorResponse | (SuccessResponse & RiskResponseData);
export type TrustResponse = ErrorResponse | (SuccessResponse & TrustResponseData);
export type TotalScoreResponse = ErrorResponse | (SuccessResponse & TotalScoreData);
export type UserResponse = ErrorResponse | (SuccessResponse & UserResponseData);
export type GraphResponse = ErrorResponse | (SuccessResponse & GraphResponseData);

export type AirdropSignatureResponse = ErrorResponse | (SuccessResponse & { signature: string; balance: string });

export type MintResponse = ErrorResponse | (SuccessResponse & { hash: string; status: "success" | "failed" });
export type XResponse = ErrorResponse | (SuccessResponse & { url: string });

export type ErrorAction = keyof typeof API_ROUTES | "HOT";
